export default {
  data() {
    return {
      myLoading: {
        duration: 1000 * 10,
        progress: 0,
        interval: null,
      },
    }
  },

  methods: {
    startProgress(duration) {
      return new Promise((resolve) => {
        if (this.myLoading.interval) clearInterval(this.myLoading.interval)
        if (duration) {
          this.myLoading.duration = duration
        }
        this.myLoading.progress = 0

        let step = 100 / ((this.myLoading.duration) / 50) // 100% in 5s, updating every 50ms

        this.myLoading.interval = setInterval(() => {
          if (this.myLoading.progress >= 100) {
            setTimeout(() => {
              resolve(true)
              clearInterval(this.myLoading.interval)
            }, 500)
          } else {
            this.myLoading.progress += step
          }
        }, 50)
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/loading.js